import styled from 'styled-components';
import * as Text from 'theme/components/Text.style';

export const Slide = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 30px;
  min-height: 0;
  width: 100%;
`;

export const VideoSection = styled.div`
  align-items: flex-start;
  display: flex;
  flex-shrink: 1;
  justify-content: center;
  margin-top: -20px;
  min-height: 0;
  overflow: hidden;
  width: 100%;
`;

export const Video = styled.video`
  height: auto;
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  width: 100%;
`;

export const BottomSection = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 30px;
  width: 100%;
`;

export const TextSection = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;
  width: 100%;
`;

export const Header = styled(Text.H4)`
  text-align: center;
`;

export const Description = styled(Text.P2)`
  text-align: center;
`;
